import React, { useState } from "react";
import clsx from "clsx";

import VideoJS from "../../../atoms/VideoJS";
import { IActiveLearningLesson } from "../../../state";
// import { projectionPath } from "../../../teacherStore";
import { ReactComponent as IconClose } from "../../../assets/svg/close.svg";
import { ReactComponent as ArrowLeft } from "../../../assets/svg/arrow_l.svg";
import { ReactComponent as ArrowRight } from "../../../assets/svg/arrow_r.svg";

import styles from "./ActiveLearningProjectionSidebar.module.scss";

export interface ActiveLearningGuidelineSidebarProps {
  lesson: IActiveLearningLesson | null;
  prevLessonId: number | null;
  nextLessonId: number | null;
  onChangeLesson: (lessonId: number) => void;
}

export const ActiveLearningGuidelineSidebar: React.FC<ActiveLearningGuidelineSidebarProps> = ({
  lesson,
  prevLessonId,
  nextLessonId,
  onChangeLesson,
}) => {
  const [showVideo, setShowVideo] = useState(false);
  const [videoOptions, setVideoOptions] = useState({ url: "", playing: false });

  const handleOpenVideo = () => {
    setShowVideo(true);
    setVideoOptions({
      url: `https://t.enageed.net/movie/ACTIVELEARNING/active_learning_theme_movie_enageed/active_learning_theme_movie_enageed`,
      playing: false,
    });
  };

  const handleCloseVideo = () => {
    setVideoOptions(prevState => ({
      ...prevState,
      playing: false,
    }));
    setShowVideo(false);
  };

  const prevLesson = () => prevLessonId && onChangeLesson(prevLessonId);
  const nextLesson = () => nextLessonId && onChangeLesson(nextLessonId);

  return (
    <div className={styles.container}>
      <ul className={styles.menuList}>
        <li>
          {[
            "やりたいことのタネを探そう",
            "自分がワクワクする「問い」を見つけよう",
          ].includes(`${lesson?.title}`) && (
            <button
              onClick={handleOpenVideo}
              className={clsx(styles.actionBtn, styles.primary)}
            >
              動画
            </button>
          )}
        </li>
        <li>
          <button
            className={styles.nextBtn}
            onClick={prevLesson}
            disabled={!prevLessonId}
          >
            <ArrowLeft className={styles.arrow} />
            前の教材
          </button>
          <button
            className={styles.nextBtn}
            onClick={nextLesson}
            disabled={!nextLessonId}
          >
            <ArrowRight className={styles.arrow} />
            次の教材
          </button>
        </li>
      </ul>
      <div
        className={styles.video}
        style={{
          display: showVideo && videoOptions.url.length > 0 ? "block" : "none",
        }}
      >
        <div className={styles.close} onClick={handleCloseVideo}>
          <IconClose />
        </div>
        {!!videoOptions.url && (
          <VideoJS
            key={videoOptions.url}
            className={styles.videojs}
            playing={videoOptions.playing}
            showVideo={showVideo}
            sourceUrl={videoOptions.url}
          />
        )}
      </div>
    </div>
  );
};

export default ActiveLearningGuidelineSidebar;
